import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormService } from 'src/app/services/form.service';
import { FormGroup } from '@angular/forms';
import { ModalService } from 'src/app/services/modal.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { AppConstants } from 'src/app/app.constants';
import { ClipboardService } from 'ngx-clipboard';
import { UtilsService } from 'src/app/services/utils.service';
import { VotacionService } from 'src/app/services/votacion.service';

@Component({
  selector: 'app-votacionmodal',
  templateUrl: './votacionmodal.component.html',
  styleUrls: ['./votacionmodal.component.css']
})
export class VotacionmodalComponent implements OnInit {

  @Input() data;
  form: FormGroup;
  submitted: Boolean = false;
  usuario: any;
  // comboEstatus: any;
  // combosList: any;

  constructor(private activeModal: NgbActiveModal, private formService: FormService, private modal: ModalService,
    private alert: NotificacionesService, private utils: UtilsService, private clipboard: ClipboardService, private votacionService: VotacionService) {
    // this.combosList = [];
    // this.comboEstatus = [
    //   { idEstatusVotacion: 1, nombreEstatus: 'En configuración' },
    //   { idEstatusVotacion: 2, nombreEstatus: 'Lista' },
    //   { idEstatusVotacion: 3, nombreEstatus: 'En proceso' },
    //   { idEstatusVotacion: 4, nombreEstatus: 'Finalizada' },
    //   { idEstatusVotacion: 5, nombreEstatus: 'Publicada' },
    //   { idEstatusVotacion: 6, nombreEstatus: 'Cancelada' }];
    // this.combosList.push(this.comboEstatus);
  }

  ngOnInit(): void {
    this.usuario = this.utils.obtenerDatosUsuario().usuario;
    this.form = this.formService.getVotacionesModalForm(this.data, this.usuario);
  }

  accept() {
    this.submitted = true;
    if (this.form.invalid)
      return;
    this.modal.mostrarModalCargando();
    if (this.form.value.idVotacion > 0)
      this.update(this.form.value);
    else
      this.save(this.form.value);
  }

  save(votacion) {
    let publicKey = this.utils.obtenerLlavePublicaPaillier(votacion.llavePublica);
    if (!this.utils.validarObjeto(publicKey)) {
      this.alert.warning('El valor que introdujo no pertenece a una llave válida, intente de nuevo', true);
      this.modal.cerrarModalCargando();
      return;
    }
    let request = {
      idVotacion: votacion.idVotacion,
      tituloVotacion: votacion.tituloVotacion,
      fechaInicio: this.utils.concatenarFechaHora(votacion.fechaInicio, votacion.horaInicio),
      fechaFin: this.utils.concatenarFechaHora(votacion.fechaFin, votacion.horaFin),
      descripcion: votacion.descripcion,
      llavePublica: votacion.llavePublica,
      hashVotacion: votacion.hashVotacion,
      hashBoleta: votacion.hashBoleta,
      hashVotantes: votacion.hashVotantes,
      usuario: votacion.usuario
    };
    this.votacionService.guardar(request).subscribe((data: any) => {
      this.modal.cerrarModalCargando();
      if (this.utils.validarObjeto(data) && data.codigo === AppConstants.RESPONSECODES.OK) {
        this.alert.success(data.mensaje, true);
        this.close();
      }
      else
        this.alert.error(data.mensaje, true);
    }, (error: any) => {
      console.error('Error', error);
      this.modal.cerrarModalCargando();
      this.alert.error('No se pudo guardar la votación, intente de nuevo', true);
    });
  }

  update(votacion) {
    let publicKey = this.utils.obtenerLlavePublicaPaillier(votacion.llavePublica);
    if (!this.utils.validarObjeto(publicKey)) {
      this.alert.warning('El valor que introdujo no pertenece a una llave válida, intente de nuevo', true);
      this.modal.cerrarModalCargando();
      return;
    }
    let request = {
      idVotacion: votacion.idVotacion,
      tituloVotacion: votacion.tituloVotacion,
      fechaInicio: this.utils.concatenarFechaHora(votacion.fechaInicio, votacion.horaInicio),
      fechaFin: this.utils.concatenarFechaHora(votacion.fechaFin, votacion.horaFin),
      descripcion: votacion.descripcion,
      llavePublica: votacion.llavePublica,
      hashVotacion: votacion.hashVotacion,
      hashBoleta: votacion.hashBoleta,
      hashVotantes: votacion.hashVotantes,
      usuario: votacion.usuario,
      idEstatusVotacion: this.utils.validarObjeto(votacion.estatusVotacion) ? votacion.estatusVotacion.idEstatusVotacion : 0
    };
    this.votacionService.actualizar(request).subscribe((data: any) => {
      this.modal.cerrarModalCargando();
      if (this.utils.validarObjeto(data) && data.codigo === AppConstants.RESPONSECODES.OK) {
        this.alert.success(data.mensaje, true);
        this.close();
      }
      else
        this.alert.error(data.mensaje, true);
    }, (error: any) => {
      console.error('Error', error);
      this.modal.cerrarModalCargando();
      this.alert.error('No se pudo actualizar la votación, intente de nuevo', true);
    });
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  close() {
    this.activeModal.close();
  }

}
